import { defineMessages } from "react-intl";

export default defineMessages({
  allowtrans: {
    id: "profile.allowtrans"
  },
  backupButton: {
    id: "profile.backup.downloadButtonText"
  },
  backupDescription: {
    id: "profile.backup.description"
  },
  backupText: {
    id: "profile.backup.rhDescription"
  },
  backupTitle: {
    id: "profile.backup.title"
  },
  backupToastCreated: {
    id: "profile.backup.toastCreated"
  },
  backupToastStarted: {
    id: "profile.backup.toastStart"
  },
  backupTooltip: {
    id: "profile.backup.downloadButtonTooltip"
  },
  cardview: {
    id: "profile.cardview"
  },
  code: {
    id: "profile.code"
  },
  dark: {
    id: "profile.dark"
  },
  editorsettings: {
    id: "profile.editorsettings"
  },
  editorsettingsdesc: {
    id: "profile.editorsettingsDesc"
  },
  editorview: {
    id: "profile.editorview"
  },
  forms: {
    id: "profile.forms"
  },
  generatorview: {
    id: "profile.generatorview"
  },
  language: {
    id: "profile.language"
  },
  light: {
    id: "profile.light"
  },
  listview: {
    id: "profile.listview"
  },
  no: {
    id: "no"
  },
  showTooltips: {
    id: "showTooltips"
  },
  theme: {
    id: "profile.theme"
  },
  tnheading: {
    id: "topnav.heading"
  },
  tntitle: {
    id: "topnav.title"
  },
  userinterface: {
    id: "profile.userinterface"
  },
  userinterfaceDesc: {
    id: "profile.userinterfaceDesc"
  },
  yes: {
    id: "yes"
  },
});



// WEBPACK FOOTER //
// ./src/Containers/Profile/translations.js